<h2 mat-dialog-title>{{ data.title }}</h2>
<div mat-dialog-content [formGroup]="form">
  <div fxLayout="column" fxLayoutGap="10px">
    <mat-form-field appearance="outline" fxFlex>
      <mat-label>Name</mat-label>
      <input formControlName="name" matInput />
    </mat-form-field>
    <mat-form-field appearance="outline" fxFlex>
      <mat-label>Description</mat-label>
      <textarea formControlName="description" matInput></textarea>
    </mat-form-field>
    <app-zip-picker
      #zone
      fxLayoutGap="30px"
      [zips]="form.get('zips').value"
      (scheduleUpdated)="form.get('zips').setValue($event)"
      [showCopy]="false"
    ></app-zip-picker>
    @if (data.zone.id) {
      <rspl-info-box style="margin-bottom: 15px">
        Please be aware that in order for these changes to take effect, you will have to reapply this saved zone to your default/weekly
        schedule
      </rspl-info-box>
    }
    <mat-slide-toggle
      style="margin-bottom: 15px; margin-top: -10px"
      [checked]="!hasParent.value"
      (toggleChange)="hasParent.setValue(!hasParent.value)"
      color="primary"
    >
      Make this zone globally available for the whole fleet
    </mat-slide-toggle>

    <div style="height: 300px">
      <rspl-map
        style="height: 300px; max-height: 300px"
        [height]="'300px'"
        [showZips]="true"
        [selectedZips]="form.get('zips').value"
        (zipSelectionUpdated)="form.get('zips').setValue($event)"
        [showAllZips]="true"
        [hoverableZips]="true"
        [selectableZips]="true"
        [showAddressSearch]="false"
      />
    </div>
  </div>
</div>
<div mat-dialog-actions fxLayout="row" fxLayoutAlign="flex-end">
  <button mat-button (click)="close()" [disabled]="isSaving">Back</button>
  <button class="primary-btn filled-btn" mat-raised-button rsplDisableDoubleClick (oneClick)="save()" [ladda]="isSaving">Save</button>
</div>
